import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import Button from 'flarum/common/components/Button';
import NewModal from '../modal/NewModal';

export default function extendLogInButtons() {
  extend(LogInButtons.prototype, 'items', function (items) {
    // items.add(
    //   'cjlu-auth-new',
    //   <Button onclick={() => app.modal.show(NewModal)} className="Button Button--block LogInButton--cjlu-new">
    //     新生通道
    //   </Button>
    // );

    items.add(
      'cjlu-auth-invite',
      <Button onclick={() => app.modal.show(SignUpModal)} className="Button Button--block LogInButton--cjlu-invite">
        特邀注册
      </Button>
    );
  });
}
